/**
 * Loading recoil
 */

// Recoil
import { atom } from 'recoil';

export const loadingAtom = atom({
  key: 'loadingAtom',
  default: false,
});
